import { setPollingOnce } from '@shared/helpers/setPolling';
import { utiqMachine } from '../../../machine';
import { TemplateData } from './types';

/**
 * Reads templateData from Utiq namespace or delegates a request for a new templateData and assigns it to the Utiq namespace
 *
 * @param host - Current host from which the path to the correct templateData will be created for the request
 * @param isLocalOrUatEnvironment - Boolean value used for making a decision on templateData origin, UAT or production
 * @returns TemplateData object or null
 *
 */
export const getTemplateContent = async () => {
  await utiqMachine.run();

  const val = await new Promise<TemplateData>((done) =>
    setPollingOnce(
      () => done(window.Utiq?.data?.popupContent!),
      () => !!utiqMachine.ctx.window.Utiq?.data?.popupContent,
    ),
  );

  return val;
};
